import district from '@/api/district';

import {
    GET_DISTRICT_LIST_BEGIN,
    GET_DISTRICT_LIST_SUCCESS,
    GET_DISTRICT_LIST_FAILURE,
} from './types';

const initialState = {
    listDistrictError: false,
    districtList: false,
};

const getters = {
    districtList:(state) => state.districtList,
    listDistrictError:(state) => state.listDistrictError,
};

const actions = {
    getDistrictList({ commit }, filter) {
        commit(GET_DISTRICT_LIST_BEGIN);
        return district.getDistrictList(filter)
            .then((response) => commit(GET_DISTRICT_LIST_SUCCESS, response.data))
            .catch((error) => commit(GET_DISTRICT_LIST_FAILURE, error.response?.data || { detail: error.message }));
    },
};

const mutations = {
    [GET_DISTRICT_LIST_BEGIN](state) {
        state.listDistrictError = false;
        state.districtList = false;
    },
    [GET_DISTRICT_LIST_SUCCESS](state, data) {
        state.districtList = data;
        state.listDistrictError = false;
    },
    [GET_DISTRICT_LIST_FAILURE](state, error) {
        state.listDistrictError = error;
    },
};

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations,
};
